import { render, staticRenderFns } from "./tabs-selector.vue?vue&type=template&id=5817fb9c&scoped=true"
import script from "./tabs-selector.vue?vue&type=script&lang=js"
export * from "./tabs-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5817fb9c",
  null
  
)

export default component.exports